import React from 'react';
import './InputField.css';

interface InputFieldProps {
  label: string;
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  keyboardType?: 'default' | 'email-address' | 'phone-pad';
  secureTextEntry?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  value,
  onChangeText,
  placeholder,
  keyboardType = 'default',
  secureTextEntry = false,
}) => {
  const inputType = secureTextEntry ? 'password' : 
                   keyboardType === 'email-address' ? 'email' :
                   keyboardType === 'phone-pad' ? 'tel' : 'text';

  return (
    <div className="input-field">
      <label className="input-label">{label}</label>
      <input
        type={inputType}
        value={value}
        onChange={(e) => onChangeText(e.target.value)}
        placeholder={placeholder}
        className="input-text"
      />
    </div>
  );
};
